module.exports = "/lucky-balls/img/bigball/BigBall_000.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_000.png
// module id = 895
// module chunks = 0